import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import axios from "axios";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  //Hook

  // declare usefull auth states

  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  //Function
  const login = useCallback((token, user) => {
    setToken(token);
    setUser(user);
    localStorage.setItem("admin_DigitalMasters", JSON.stringify({ token, user }));
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("admin_DigitalMasters");
  }, []);

  useEffect(() => {
    const storedData = localStorage.getItem("admin_DigitalMasters");
    if (storedData) {
      const adminData = JSON.parse(storedData);
      if (adminData?.token) {
        login(adminData.token, adminData.user);
        setChecked(true);
        // Ask the API whether this admin may see Exam Integrity, so a session
        // saved before the check, or one whose access changed, is corrected.
        // Any failure hides the page; the API refuses its data anyway.
        axios
          .get(process.env.REACT_APP_BACKEND_URL + "adminAuth/me", {
            headers: { Authorization: `Bearer ${adminData.token}` },
          })
          .then((res) => res?.data?.data?.canReviewIntegrity === true)
          .catch(() => false)
          .then((canReviewIntegrity) => {
            // Skip if the admin logged out or switched accounts meanwhile.
            const current = JSON.parse(localStorage.getItem("admin_DigitalMasters") || "null");
            if (current?.token === adminData.token) {
              login(adminData.token, { ...adminData.user, canReviewIntegrity });
            }
          });
      }
    }
    setChecked(true);
  }, [login]);

  //Return
  return (
    <AuthContext.Provider value={{ token, user, checked, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
